import { getCustomerProductListTypeProductLists } from '@ori/global-api-client-react';

import type { ApiProps } from './types';

export const getFavoriteProductsList = async ({ client, customerId }: ApiProps) => {
  const { data } = await getCustomerProductListTypeProductLists(client, customerId, 'Favorite');
  if (data.productLists.length > 0) {
    const [list] = data.productLists;
    const { items, productListId } = list;

    return { items, productListId };
  }

  return undefined;
};
